import { FC } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import executeCheckout from "../../api/executeCheckout";
import executeReschedule from "../../api/executeReschedule";
import { ISchedule } from "../../api/getSchedulesAvailable";
import Button from "../buttons/Button";
import { getCreditCardFlag } from "../utils/creditCardUtils";
import getUserData from "../utils/getUserData";
import {
	BuyDetailsInterface,
	CheckoutStepperBody,
	CheckoutStepperFooter,
	CheckoutStepperHeader,
	CheckoutStepperWrapper,
	FooterButtonWrapper,
	InputLabel,
	ItemBuy,
	YourBuyRow,
	YourBuyWrapper,
} from "./CheckoutCommon";
import CreditCardIcon from "./CreditCadIcon";

interface FinishCheckoutStepProps {
	checkoutId: string | undefined;
	purchaseData: BuyDetailsInterface | undefined;
	scheduleInfo?: ISchedule | undefined;
	rescheduleId?: string;
}

const PaymentInfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: normal;
	gap: 5px;
	padding-left: 5px;
	p {
		margin: 0;
	}
`;

const FinishCheckoutStep: FC<FinishCheckoutStepProps> = ({ checkoutId, purchaseData, rescheduleId, scheduleInfo }) => {
	const navigate = useNavigate();
	const { skipPayment, ...personalData } = getUserData();
	const numeroCartao = purchaseData?.numero || "";

	const handleExecuteCheckout = async () => {
		if (checkoutId) {
			const response = await executeCheckout(checkoutId, personalData, purchaseData, skipPayment);
			if (response && response.success) {
				sessionStorage.setItem("status", "scheduled");
				navigate("/success", { replace: true });
			} else {
				navigate(-1);
			}
		}
	};

	const handleReschedule = async () => {
		if (checkoutId && rescheduleId) {
			const response = await executeReschedule(rescheduleId, checkoutId, { ...personalData, skipPayment }, purchaseData);
			if (response && response.success) {
				sessionStorage.setItem("status", "rescheduled");
				navigate("/success", { replace: true });
			} else {
				navigate(-1);
			}
		}
	};

	return (
		<CheckoutStepperWrapper>
			<CheckoutStepperHeader>
				<p>{skipPayment ? "Detalhes do agendamento" : "Detalhes da compra"}</p>
			</CheckoutStepperHeader>
			<YourBuyWrapper>
				<YourBuyRow>
					<InputLabel>
						{skipPayment ? "Seu agendamento:" : "Sua compra:"}
					</InputLabel>
				</YourBuyRow>
				{scheduleInfo && scheduleInfo.procedimento && (
					<ItemBuy descricao={`${scheduleInfo.procedimento.descricao} - ${scheduleInfo.convenio} `} valor={scheduleInfo.valor} quantidade={1} />
				)}
			</YourBuyWrapper>
			{!skipPayment && (
				<CheckoutStepperBody>
					<InputLabel>
						<b>Pagamento com:</b>
					</InputLabel>
					<PaymentInfoWrapper>
						{/* Alterar icone do cartão conforme bandeira */}
						<CreditCardIcon flag={getCreditCardFlag(numeroCartao)} />
						<InputLabel>
							{" "}
							{purchaseData?.bandeira.toUpperCase() !== "UNKNOWN" || "CARTAO"} terminado em *
							{numeroCartao.slice(numeroCartao.length - 4, numeroCartao.length)}
						</InputLabel>
					</PaymentInfoWrapper>
				</CheckoutStepperBody>
			)}
			<CheckoutStepperFooter>
				<FooterButtonWrapper>
					<Button onClick={rescheduleId ? handleReschedule : handleExecuteCheckout}>
						{rescheduleId ? "Reagendar" : skipPayment ? "Finalizar agendamento" : "Finalizar compra"}
					</Button>
				</FooterButtonWrapper>
			</CheckoutStepperFooter>
		</CheckoutStepperWrapper>
	);
};

export default FinishCheckoutStep;
